import useAppStore from "@/context/store";
import { getOrgIdByUser } from "@/utils/gaoding";
import { MEMBER_MANAGEMENT_PAGE } from "@/utils/host";
import { Button } from "antd";
import GdOrgSwitchDialog, { useOrgList } from "../GdOrgSwitch";
import HBIcon from "../HBIcon";
import HBModal, { ModalProps } from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import styles from "./index.module.less";

export enum GD_PERMISSION_TYPE {
  /**访客角色无权限 */
  visitor = "visitor",
  /**被踢出租户 */
  remove = "remove",
  /**当前租户无授权 */
  noauth = "noauth",
  /**当前租户无会员权益 */
  noright = "right",
  /**租户不存在或被解散 */
  noorg = "noorg",
  /**没有权限 */
  nopermission = "nopermission",
  /**自定义 */
  custom = "custom",
}

interface IProps {
  type: GD_PERMISSION_TYPE;
  /**操作文案 */
  operation?: string;
  onCancel?: () => void;
  title?: string;
  content?: React.ReactNode;
}

export function GdPermissionDialog(props: IProps & ModalProps) {
  const type = props.type || GD_PERMISSION_TYPE.noauth;
  const operation = props.operation || "访问当前页面";

  const { user, orgInfo } = useAppStore((s) => ({
    orgInfo: s.orgInfo,
    user: s.user,
  }));

  const { orgList } = useOrgList();

  const onSwitchOrg = () => {
    props.onCancel?.();
    GdOrgSwitchDialog.open({
      orgList,
    });
  };

  // 不相等说明 orgInfo 在请求中，等一致了在显示
  if (getOrgIdByUser(user) !== orgInfo?.org?.id?.value && orgInfo?.org) {
    return null;
  }

  return (
    <HBModal
      {...props}
      width={400}
      title={null}
      footer={null}
      className={styles.modal}
    >
      <div className={styles.title}>
        <HBIcon type="ic_lock" /> {props.title || "无权访问"}
      </div>

      <div className={styles.desc}>
        {/* 没有权限 */}
        {type === GD_PERMISSION_TYPE.nopermission && (
          <>
            您没有权限{operation}，请联系企业管理员!
            <br />
            若您已购买「素材下载会员」，请
            <a
              className="primary-text-btn"
              onClick={() => {
                window.location.reload();
              }}
            >
              刷新页面
            </a>
            重试。
          </>
        )}
        {/* 访客 */}
        {type === GD_PERMISSION_TYPE.visitor && (
          <>
            当前组织为
            <span className={styles.blueColor}>{orgInfo?.org?.name}</span>
            ；你的身份是 <span className="color-primary">「访客」</span>
            无权{operation}，请联系企业管理员!
          </>
        )}
        {/* 被踢出租户 */}
        {type === GD_PERMISSION_TYPE.remove && (
          <>
            你已被移出
            <span className={styles.blueColor}>{orgInfo?.org?.name}</span>
            ；无权{operation}，请联系企业管理员!
          </>
        )}
        {/* 切换租户 */}
        {type === GD_PERMISSION_TYPE.noauth && (
          <>
            当前企业为
            <span className={styles.blueColor}>{orgInfo?.org?.name}</span>
            无权{operation}；若要继续访问，需切换回之前企业
          </>
        )}
        {type === GD_PERMISSION_TYPE.noright && (
          <>
            当前企业为
            <span className={styles.blueColor}>{orgInfo?.org?.name}</span>
            无素材会员权益；请切换至其他组织
          </>
        )}
        {type === GD_PERMISSION_TYPE.noorg && (
          <>当前企业为被解散，请切换至其他组织</>
        )}

        {type === GD_PERMISSION_TYPE.custom && props.content}
      </div>

      <div className={styles.footer}>
        <Button type="default" onClick={onSwitchOrg}>
          切换组织
        </Button>
        <Button type="primary" onClick={props.onOk}>
          我知道了
        </Button>
      </div>
    </HBModal>
  );
}

export default ModalWrap(GdPermissionDialog, {
  unique: true,
});

export const SetDownloadMemberInfo = ModalWrap(function (props: ModalProps) {
  const { orgList } = useOrgList();
  const onSwitchOrg = (e) => {
    props.onCancel?.(e);
    GdOrgSwitchDialog.open({
      orgList,
    });
  };

  return (
    <HBModal
      {...props}
      width={400}
      title={null}
      footer={null}
      className={styles.modal}
    >
      <div className={styles.title}>功能使用受限</div>

      <div className={styles.desc}>
        您当前没有素材下载席位，无法使用该功能，您可在
        <a
          className="primary-text-btn"
          target="_blank"
          href={MEMBER_MANAGEMENT_PAGE}
        >
          「成员管理」
        </a>
        中分配席位后使用。
      </div>

      <div className={styles.footer}>
        <Button type="default" onClick={onSwitchOrg}>
          切换组织
        </Button>
        <Button type="primary" onClick={props.onOk}>
          我知道了
        </Button>
      </div>
    </HBModal>
  );
});
